import React, { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import Button from "../Components/Button";
import { AdminAuthService } from "../services/adminAuthService";

export default function Login() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const authService = useMemo(() => new AdminAuthService(), []);
  const next =
    (location.state as { from?: string } | null)?.from || "/home-hub";

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);

    try {
      await authService.login(password);
      navigate(next, { replace: true });
    } catch (err: any) {
      setError(err?.message || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="launch-pad d-flex flex-column align-items-center justify-content-center">
      <form
        onSubmit={onSubmit}
        className="card-tile p-4"
        style={{ width: 340, maxWidth: "90vw" }}
      >
        <h4 className="mb-3">Home Hub Login</h4>
        <input
          className="form-control mb-3"
          type="password"
          placeholder="Admin password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
        />
        <Button
          type="submit"
          className="primary-button p-3 w-100"
          disabled={busy || !password}
        >
          {busy ? "Signing in..." : "Sign In"}
        </Button>
        {error && (
          <div style={{ marginTop: 12, color: "crimson", textAlign: "left" }}>
            {error}
          </div>
        )}
      </form>
    </div>
  );
}
